import {
  SET_LOADING,
  SAVE_DATA,
  SET_FILTER,
  SET_ACTIVE_PAGE,
  CITY_LOADING,
  SET_CITY_OPTIONS,
  SET_CITY_SELECTED_OPTION,
  SAVE_VM_LIST_DATA,
  SAVE_VM_DETAILS_DATA
} from './constants';

export function setLoading(isLoading) {
  return {
    type: SET_LOADING,
    isLoading,
  };
}

export function saveData(data) {
  return {
    type: SAVE_DATA,
    data,
  };
}
export function saveVMListData(data) {
  console.log('saveVMListData-----', data);
  return {
    type: SAVE_VM_LIST_DATA,
    data,
  };
}
export function setFilter(filter) {
  return {
    type: SET_FILTER,
    filter,
  };
}
export function saveVMDetailsData(data) {
  console.log('saveVMListData-----', data);
  return {
    type: SAVE_VM_DETAILS_DATA,
    data,
  };
}


export function setActivePage(pageNumber) {
  return {
    type: SET_ACTIVE_PAGE,
    pageNumber,
  };
}

export function setDropdownLoading(loading) {
  return {
    type: CITY_LOADING,
    loading,
  };
}

export function setCityOptions(options) {
  return {
    type: SET_CITY_OPTIONS,
    options,
  };
}

export function setCitySelectedOptions(value) {
  return {
    type: SET_CITY_SELECTED_OPTION,
    value,
  };
}



// WEBPACK FOOTER //
// ./src/Modules/VMs/actions.js